import { useEffect } from "react";
import { setWebListConfig } from "../../../redux/slices/videoDataSlice";
import { responseValidator } from "../../helpers";
import { apiCaller } from "../../../services/apiCaller";
import { API } from "../../../services/services";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { shallowEqual } from "react-redux";

const useWebListConfig = () => {
    const dispatch = useAppDispatch();
    const { params, token, isLiveError } = useAppSelector(
        ({ videoData: { params, token, isLiveError } }) => ({ params, token, isLiveError }),
        shallowEqual
    );

    useEffect(() => {
        (async () => {
            const response = await apiCaller({ url: API().web_list_config(), data: { limit: 1000, offset: 0 } });
            if (response && responseValidator(response.status)) dispatch(setWebListConfig(response.data.results));
        })();
    }, [isLiveError, token, params.id]);
};

export default useWebListConfig;
